import { Collapse } from '@mui/material';
import { OptionallyVisible } from 'components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Panel } from 'components/containers';

import { CryptoPayout } from 'types/cryptoPayout';
import { ReduxToolkitError, ReduxToolkitResponse } from 'types/http';

import LABELS from './keys';
import { CollapseContent, ErrorText, ExpandSectionHandle, ExpandSectionIcon, Header, Item, StyledButton } from './styles';

export interface StatusPayoutInfoProps {
  cancel: () => Promise<ReduxToolkitResponse<{ data: CryptoPayout }>>;
  isLoading: boolean;
  error?: ReduxToolkitError;
}

export const CancelPayout = ({ cancel, isLoading, error }: StatusPayoutInfoProps) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggle = () => {
    setIsExpanded(!isExpanded);
  };

  const onCancelClick = () => {
    cancel();
  };

  return (
    <Panel>
      <ExpandSectionHandle flat onClick={toggle}>
        <Header>{t(LABELS.HEADER)}</Header>
        <ExpandSectionIcon isExpanded={isExpanded} />
      </ExpandSectionHandle>
      <Collapse in={isExpanded}>
        <CollapseContent>
          <Item>
            <StyledButton secondary isLoading={isLoading} onClick={onCancelClick}>
              {t(LABELS.ACTION_LABEL)}
            </StyledButton>
            <OptionallyVisible visible={Boolean(error)}>
              <ErrorText>{(error as ReduxToolkitError)?.data?.errorMessage || t(LABELS.GENERIC_CANCELLATION_ERROR)}</ErrorText>
            </OptionallyVisible>
          </Item>
        </CollapseContent>
      </Collapse>
    </Panel>
  );
};

export default CancelPayout;
